import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { TabNav, TabNavItem } from 'src/domains/sportsbook/trading/view/eventDetails/EventDetails.style';

type CustomerRouteType =
    | 'event-settings'
    | 'markets'
    | 'tags'
    | 'results'
    | 'debug';

export const EventTabItems = observer((): JSX.Element | null => {
    const { routerBackoffice } = useAppStateContext();
    const customerParams = routerBackoffice.getParametersString('events', 'tab') ?? 'event-settings';

    const isTabActive = (label: string): boolean => {
        return customerParams === label;
    };

    interface MenuItems {
        id: CustomerRouteType;
        label: string;
        onClick: () => void;
    }

    const menuItems: Array<MenuItems> = [
        {
            id: 'event-settings',
            label: 'Event settings',
            onClick: (): void => routerBackoffice.redirectToTradingEventDetailsSettings(),
        },
        {
            id: 'markets',
            label: 'Markets',
            onClick: (): void => routerBackoffice.redirectToTradingEventDetailsMarkets(),
        },
        {
            id: 'tags',
            label: 'Tags',
            onClick: (): void => routerBackoffice.redirectToTradingEventDetailsTags(),
        },
        {
            id: 'results',
            label: 'Results',
            onClick: (): void => routerBackoffice.redirectToTradingEventDetailsResults(),
        },
        {
            id: 'debug',
            label: 'Debug',
            onClick: (): void => routerBackoffice.redirectToTradingEventSettings(),
        }
    ];

    return (
        <TabNav>
            {menuItems.map(linkItem => (
                <TabNavItem
                    key={linkItem.id}
                    isActive={isTabActive(linkItem.id)}
                    onClick={linkItem.onClick}
                    data-test={linkItem.id}
                >
                    {linkItem.label}
                </TabNavItem>
            ))}
        </TabNav>
    );
});
